import { postApiPracticesPracticeIdPatientsSearch } from "@/lib/api-client/endpoints/patient/patient";
import { useTokenPagedInfiniteQuery } from "@/lib/query/useTokenPagedInfiniteQuery";
import { PatientSearchResult } from "lib/api-types/schemas";
import { PAGE_SIZE } from "@/lib/query/constants";

async function fetchPatientPage(
  practiceId: string,
  query: string,
  nextToken?: string,
) {
  const res = await postApiPracticesPracticeIdPatientsSearch(practiceId, {
    filter: { query },
    pageSize: PAGE_SIZE,
    nextToken,
  });

  return {
    items: res.data.items ?? [],
    nextToken: res.data.nextToken,
  };
}

export const patientSearchQueryKey = (practiceId: string, query: string) =>
  ["patients", "search", practiceId, query] as const;

export function usePatientSearch(practiceId: string, query: string) {
  return useTokenPagedInfiniteQuery<PatientSearchResult>({
    queryKey: patientSearchQueryKey(practiceId, query),
    fetchPage: (nextToken?: string) =>
      fetchPatientPage(practiceId, query, nextToken),
    enabled: query.length > 0,
  });
}
